var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgSystem(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.16 14.136c.001 1.011-.12 2.019-.36 3a11.774 11.774 0 01-11.317 9.135c-.721.002-1.44-.069-2.148-.21a12.012 12.012 0 01-9.53-11.925 12.047 12.047 0 018.923-11.792l.616-.14c.37-.071.757-.124 1.144-.16.387-.034.66 0 .995 0A11.906 11.906 0 0130.16 14.137z",
    fill: "#F7C694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.866 14.136c0 1.011-.12 2.019-.361 3a11.862 11.862 0 01-9.17 8.924 12.012 12.012 0 01-9.53-11.924 12.047 12.047 0 018.923-11.792l.616-.14a12.03 12.03 0 019.522 11.932z",
    fill: "#FD9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.193 46H5.863c-2.64 0-4.462-2.842-3.687-5.631a17.362 17.362 0 017.427-10.34 8.613 8.613 0 012.71-1.11h.405c.185-.012.37-.012.555 0H13.58l.423.071c.847.215 1.709.362 2.578.44.572.07 1.162.106 1.76.123h.212a1.134 1.134 0 011.152 1.488c-.204.99-.308 1.998-.308 3.01a14.581 14.581 0 001.672 6.793c.427.803.924 1.566 1.488 2.28A1.76 1.76 0 0121.193 46z",
    fill: "#C7E689"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.193 46h-9.337c-2.64 0-4.461-2.842-3.687-5.632a17.363 17.363 0 017.427-10.34 5.842 5.842 0 011.02-.546c.573.07 1.163.106 1.76.124h.212a1.136 1.136 0 011.118 1.434c-.205.99-.308 1.999-.308 3.01a14.582 14.582 0 001.672 6.793 15.13 15.13 0 001.487 2.28A1.761 1.761 0 0121.193 46z",
    fill: "#B1CC7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.12 38.566a11.985 11.985 0 11-19.695-12.901 1.152 1.152 0 011.69.079l6.265 7.515a1.937 1.937 0 001.62.687l9.926-.713a.978.978 0 011.073 1.03 17.182 17.182 0 01-.88 4.303z",
    fill: "#8C8CFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.468 31.71l-8.923.642a1.637 1.637 0 01-1.381-.581L28.4 24.88a1.665 1.665 0 01.43-2.49A11.59 11.59 0 0146 29.684a1.653 1.653 0 01-1.532 2.024z",
    fill: "#FF8C9F"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h44v44H0z"
  })))));
}
export default SvgSystem;